<template>
	<!-- 短信校验码 -->
    <div class="wkInputPhoneValidate wk-input-box flex">
        <span class="input-left-label">{{label}}</span>
        <div class="flex-jf-btw">
            <input-base type="number" v-model="inputVal" :initVal="value" 
				:placeholder="placeholderOver" maxlength="6" styleCpt="height:2.1rem;" />
			<p class="imgCode-box" @click="getImgCode"> 
				<img :src="imgCodeUrl"/> 
			</p>
        </div>
    </div>
</template>
 
<script>
    export default {
        name: 'inputlsit',
		props: ['label', 'placeholder','value','imgCodeUrlOut'],
		mounted(){
			this.placeholderOver = this.label;
      this.imgCodeUrl = this.imgCodeUrlOut;
			if(this.placeholder){
				this.placeholderOver = this.this.placeholder;
			}

      if(this.$route.path!='/forgetpwd/phone' && this.$route.path!='/register/phone'){
        console.log('呢买也买你')
        this.getImgCode();
      }
			// this.getImgCode();
		},
		data(){
			return {
				imgCodeUrl:'', //图形验证码
				inputVal:'',
				placeholderOver:'',
				imgCodeUrlId:''
			}
		},
		watch:{
            inputVal(){
                this.$emit('input',this.inputVal)
            },
            imgCodeUrlOut(val){
              this.imgCodeUrl = val
            }
        },
		methods:{
			//获取图形验证码
			getImgCode(){
				let that = this;
				that.$axios_post('other/picVerificationCode').then((res)=>{
					//console.log('获得图形验证码',res)
					if(res.code == '00000000'){
						that.imgCodeUrl = 'data:image/png;base64,' + res.data.image;
						that.imgCodeUrlId = res.data.imageUUID;
					}
				})
			},
			//获得当前验证码的id
			getImgCodeUrlId(){
				return this.imgCodeUrlId;
            },
            //校验图片验证码
            validImgCode(imgCode,imgCodeUrlId){
                //判断图形验证码是否输入正确
				let that = this, imgObj = {
					imageUUID:imgCodeUrlId || this.imgCodeUrlId,
					picVerificationCode: imgCode
				};
				//发送请求 验证输入的图形验证码
				that.$axios_post('other/picVerificationCode/validate',imgObj).then((res)=>{
					//console.log('验证图形验证码',res)
					if(res.code == '00000000'){
                        that.$emit('succFn');
					}else{
                        //错误提示信息
                        that.$store.commit('showErrorInfo',{type:'fail',msg:'图形验证码验证失败'});
                        //调用父级的方法,如果需要做处理
                        that.$emit('failFn');
                        //如输入错误，则重新获取图形验证码
						that.getImgCode(); 
					}
				});
            },
		}
    }
</script>
<style lang="less" scoped>
    .wkInputPhoneValidate{
		margin-top:.9rem;
		>div{
			// input 输入框
			>p{
				width:10.5rem;
			}
			// 图形验证码
			>p.imgCode-box{
				width:6.25rem;
				height:2.1rem;
				border:.05rem solid #d1d1d1;
				cursor: pointer;
				img{
					height:2rem;
					width:100%;
				}
			}
		}    
    }
</style>



// WEBPACK FOOTER //
// src/components/BaseCpts/wkInputImgValidate.vue